var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpAndRunning2Switzerland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "304px",
    height: "302px",
    viewBox: "0 0 304 302",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "375A925D-EF81-40EB-A8EA-469DF2143D74@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 5,
    y: 0,
    width: 290,
    height: 138,
    rx: 8
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.1%",
    y: "-4.3%",
    width: "104.1%",
    height: "108.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.549019608   0 0 0 0 0.729411765  0 0 0 0.28392701 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 5,
    y: 156,
    width: 290,
    height: 138,
    rx: 8
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-2.1%",
    y: "-4.3%",
    width: "104.1%",
    height: "108.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.549019608   0 0 0 0 0.729411765  0 0 0 0.273137019 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-5",
    x: 0,
    y: 0,
    width: 66,
    height: 64,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.3%",
    y: "-31.2%",
    width: "166.7%",
    height: "168.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.343486631   0 0 0 0 0.287455037   0 0 0 0 0.923290308  0 0 0 0.239647072 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "path-8",
    x: 0,
    y: 0,
    width: 66,
    height: 64,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.3%",
    y: "-31.2%",
    width: "166.7%",
    height: "168.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-10"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.343486631   0 0 0 0 0.287455037   0 0 0 0 0.923290308  0 0 0 0.239647072 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "path-11",
    x: 0,
    y: 0,
    width: 66,
    height: 64,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.3%",
    y: "-31.2%",
    width: "166.7%",
    height: "168.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.343486631   0 0 0 0 0.287455037   0 0 0 0 0.923290308  0 0 0 0.239647072 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "path-14",
    x: 0,
    y: 0,
    width: 66,
    height: 64,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.3%",
    y: "-31.2%",
    width: "166.7%",
    height: "168.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-16"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.343486631   0 0 0 0 0.287455037   0 0 0 0 0.923290308  0 0 0 0.239647072 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "path-17",
    x: 0,
    y: 0,
    width: 66,
    height: 64,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.3%",
    y: "-31.2%",
    width: "166.7%",
    height: "168.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-19"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.343486631   0 0 0 0 0.287455037   0 0 0 0 0.923290308  0 0 0 0.239647072 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "path-20",
    x: 0,
    y: 0,
    width: 66,
    height: 64,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.3%",
    y: "-31.2%",
    width: "166.7%",
    height: "168.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-22"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.343486631   0 0 0 0 0.287455037   0 0 0 0 0.923290308  0 0 0 0.239647072 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "path-23",
    x: 0,
    y: 0,
    width: 66,
    height: 64,
    rx: 4
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-33.3%",
    y: "-31.2%",
    width: "166.7%",
    height: "168.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-25"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.343486631   0 0 0 0 0.287455037   0 0 0 0 0.923290308  0 0 0 0.239647072 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Up-and-Running---Switzerland",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pricing---Was-kostest-es-monatlich",
    transform: "translate(-770.000000, -245.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(350.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dialog-Box-/-Base-/-Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustration/Up-and-Running/2-SWI",
    transform: "translate(422.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C6E5F7",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-Copy"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#C6E5F7",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/_Calendar",
    transform: "translate(12.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-7)",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#008CBA",
    mask: "url(#mask-6)",
    x: 0,
    y: 0,
    width: 66,
    height: 20
  })), /*#__PURE__*/React.createElement("text", {
    id: "Month-1",
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11.632,
    y: 14
  }, "Monat 1")), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Check-Mark",
    transform: "translate(16.000000, 22.000000)",
    fill: "#006197",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "12.7170978 23.564038 6.49410176 17.1504474 4.375 19.3190716 12.7170978 27.9166667 30.625 9.46029083 28.5208215 7.29166667"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/_Calendar",
    transform: "translate(12.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-10)",
    xlinkHref: "#path-8"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#008CBA",
    mask: "url(#mask-9)",
    x: 0,
    y: 0,
    width: 66,
    height: 20
  })), /*#__PURE__*/React.createElement("text", {
    id: "Month-1",
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11.632,
    y: 14
  }, "Monat 1")), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Check-Mark",
    transform: "translate(16.000000, 22.000000)",
    fill: "#006197",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "12.7170978 23.564038 6.49410176 17.1504474 4.375 19.3190716 12.7170978 27.9166667 30.625 9.46029083 28.5208215 7.29166667"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/_Calendar",
    transform: "translate(82.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-11"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#008CBA",
    mask: "url(#mask-12)",
    x: 0,
    y: 0,
    width: 66,
    height: 20
  })), /*#__PURE__*/React.createElement("text", {
    id: "Month-1",
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11.056,
    y: 14
  }, "Monat 2")), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Check-Mark",
    transform: "translate(16.000000, 22.000000)",
    fill: "#006197",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "12.7170978 23.564038 6.49410176 17.1504474 4.375 19.3190716 12.7170978 27.9166667 30.625 9.46029083 28.5208215 7.29166667"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/_Calendar",
    transform: "translate(82.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-15",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-16)",
    xlinkHref: "#path-14"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-14"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#008CBA",
    mask: "url(#mask-15)",
    x: 0,
    y: 0,
    width: 66,
    height: 20
  })), /*#__PURE__*/React.createElement("text", {
    id: "Month-1",
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11.056,
    y: 14
  }, "Monat 2")), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Check-Mark",
    transform: "translate(16.000000, 22.000000)",
    fill: "#006197",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "12.7170978 23.564038 6.49410176 17.1504474 4.375 19.3190716 12.7170978 27.9166667 30.625 9.46029083 28.5208215 7.29166667"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/_Calendar",
    transform: "translate(152.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-19)",
    xlinkHref: "#path-17"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#008CBA",
    mask: "url(#mask-18)",
    x: 0,
    y: 0,
    width: 66,
    height: 20
  })), /*#__PURE__*/React.createElement("text", {
    id: "Month-1",
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11.248,
    y: 14
  }, "Monat 3")), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Check-Mark",
    transform: "translate(16.000000, 22.000000)",
    fill: "#006197",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "12.7170978 23.564038 6.49410176 17.1504474 4.375 19.3190716 12.7170978 27.9166667 30.625 9.46029083 28.5208215 7.29166667"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/_Calendar",
    transform: "translate(152.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-21",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-20"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-22)",
    xlinkHref: "#path-20"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-20"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#008CBA",
    mask: "url(#mask-21)",
    x: 0,
    y: 0,
    width: 66,
    height: 20
  })), /*#__PURE__*/React.createElement("text", {
    id: "Month-1",
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 11.248,
    y: 14
  }, "Monat 3")), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Check-Mark",
    transform: "translate(16.000000, 22.000000)",
    fill: "#006197",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "12.7170978 23.564038 6.49410176 17.1504474 4.375 19.3190716 12.7170978 27.9166667 30.625 9.46029083 28.5208215 7.29166667"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration/_Calendar",
    transform: "translate(222.000000, 188.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-25)",
    xlinkHref: "#path-23"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("rect", {
    fill: "#009C63",
    mask: "url(#mask-24)",
    x: 0,
    y: 0,
    width: 66,
    height: 20
  })), /*#__PURE__*/React.createElement("text", {
    id: "Month-1",
    fontFamily: "Capitolium2-Bold, Capitolium2",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 10.636,
    y: 14
  }, "Monat 4")), /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Check-Mark",
    transform: "translate(16.000000, 22.000000)",
    fill: "#008051",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "12.7170978 23.564038 6.49410176 17.1504474 4.375 19.3190716 12.7170978 27.9166667 30.625 9.46029083 28.5208215 7.29166667"
  }))), /*#__PURE__*/React.createElement("text", {
    id: "Normal",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#008CBA"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12.4433594,
    y: 21
  }, "NORMAL")), /*#__PURE__*/React.createElement("text", {
    id: "Extended",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 12,
    fontWeight: "bold",
    fill: "#008CBA"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12.0566406,
    y: 177
  }, "EXTENDED")), /*#__PURE__*/React.createElement("text", {
    id: "4.900-CHF",
    opacity: 0.488048735,
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 23,
    fontWeight: "bold",
    letterSpacing: -0.766666667,
    fill: "#005787"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16.5,
    y: 127
  }, "4.900 CHF")), /*#__PURE__*/React.createElement("text", {
    id: "9.800-CHF",
    opacity: 0.488048735,
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 23,
    fontWeight: "bold",
    letterSpacing: -0.766666667,
    fill: "#005787"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 12,
    y: 283
  }, "9.800 CHF ")), /*#__PURE__*/React.createElement("text", {
    id: "Projektlaufzeit",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 12,
    fontWeight: "normal",
    letterSpacing: -0.4,
    fill: "#47CAF5"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 66,
    y: 21
  }, "Projektlaufzeit")), /*#__PURE__*/React.createElement("text", {
    id: "Projektlaufzeit",
    fontFamily: "Roboto-Regular, Roboto",
    fontSize: 12,
    fontWeight: "normal",
    letterSpacing: -0.4,
    fill: "#47CAF5"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 75,
    y: 177
  }, "Projektlaufzeit")), /*#__PURE__*/React.createElement("text", {
    id: 90,
    opacity: 0.304734003,
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 14,
    fontWeight: "bold",
    fill: "#008CBA"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 232.967773,
    y: 128
  }, "90 ")), /*#__PURE__*/React.createElement("text", {
    id: "Tage",
    opacity: 0.304734003,
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 14,
    fontWeight: "bold",
    fill: "#008CBA"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 251.975098,
    y: 128
  }, "TAGE")), /*#__PURE__*/React.createElement("text", {
    id: 120,
    opacity: 0.304734003,
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 14,
    fontWeight: "bold",
    fill: "#008CBA"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 225.45166,
    y: 284
  }, "120")), /*#__PURE__*/React.createElement("text", {
    id: "TAge",
    opacity: 0.304734003,
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 14,
    fontWeight: "bold",
    fill: "#008CBA"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 251.975098,
    y: 284
  }, "TAGE"))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpAndRunning2Switzerland);
export default __webpack_public_path__ + "static/media/up_and_running_2_switzerland.ac20dc1652711fe5d9691731d2b781c3.svg";
export { ForwardRef as ReactComponent };